
import { useConsentHelper } from '@/composables/useConsentHelper.js';

let firstStepClickSent = false;
let googleAdsQuizStartSent = false;

export default class Tracking {

    static sendEvent(eventName, eventValue){
        useConsentHelper().sendEvent(eventName, eventValue);
    }

    /**
     * QuizStart als Google-Ads-Conversion melden.
     *
     * Laeuft direkt ueber das Google-Ads-Tag (gtag), nicht ueber GTM und
     * nicht ueber GA4. Feuert nur, wenn alle vier Bedingungen stimmen:
     *   1. Das Vertical hat googleAdsQuizStart konfiguriert (aktuell nur Treppenlift)
     *   2. Das Conversion-Label ist gesetzt
     *   3. Der beantwortete Schritt ist genau der konfigurierte Quiz-Start-Schritt
     *   4. Die Einwilligung liegt vor - belegt durch __ezaGoogleAdsReady,
     *      das nur das consent-gegatete Setup-Script in App.vue setzt
     *
     * Einmal pro Seitenaufruf, damit ein zweites Antippen der ersten Frage
     * keine zweite Conversion erzeugt.
     */
    static sendGoogleAdsQuizStart(config, stepKey){
        const quizStart = config && config.googleAdsQuizStart;

        if(!quizStart || !quizStart.label || !config.googleAdsId){
            return;
        }
        if(stepKey !== quizStart.key){
            return;
        }
        if(googleAdsQuizStartSent){
            return;
        }
        if(!window['__ezaGoogleAdsReady'] || !window['gtag']){
            return;
        }

        googleAdsQuizStartSent = true;
        const sendTo = config.googleAdsId + '/' + quizStart.label;
        console.log('Google Ads conversion', sendTo);
        window['gtag']('event', 'conversion', { 'send_to': sendTo });
    }

    static sendPageView(config, stepConfig){
        let k = 'nokey';
        if(stepConfig['key']){
            k = stepConfig['key'];

        } else if(stepConfig['component']){
            k = stepConfig['component'];

        }
        useConsentHelper().sendEvent('step-at-key_' + k);
        if(!firstStepClickSent){
            firstStepClickSent = true;
            useConsentHelper().sendEvent('first-step-click');
        }

        let title = 'notitle';
        if(stepConfig){
            title = stepConfig.component ? stepConfig.component : 'ImageStep';
            if(stepConfig.title){
                title += ' - ' + stepConfig.title;

            }

        }

        let append = '/lp/' + config.type.toLowerCase() + '/vergleich/' + k;
        let gtagEvent = {
            page_title: title,
            page_location: window.location.href,
            page_path: append
        };


        if(window['gtag']){
            console.log('gtag event', gtagEvent);
            window['gtag']('event', 'page_view', gtagEvent);
        }

        if(window['ga']){
            console.log('ga event', gtagEvent);
            window['ga']('send', 'pageview', gtagEvent.page_path, {
                title: gtagEvent.page_title
            });
        }


    }

}
